module.exports = __webpack_public_path__ + "img/trash-icon.9073f097.svg";